import store from "../../store/store"

window.receiveMessageTasks = [];
function initSignalR() {
    let reconnectCount = 0;
    const connection = new signalR.HubConnectionBuilder()
        .withUrl(store.state.baseUrl + "/chatHub")
        .withAutomaticReconnect() //断线自动重连
        .build();
    function reconnect() {
        if(reconnectCount > 3){
            return;
        }
        connection.start().then(function () {
            console.log(connection.connectionId);
        }).catch(function (err) {
            setTimeout(reconnect, 3000); // 3秒后重试
        }).finally(() => {
            reconnectCount++;
        })
    }

    reconnect();

    //自动重连成功后的处理
    connection.onreconnected(connectionId => {
        console.log(connectionId);
    });

    connection.on("ReceiveMessage", function (response) {
        window.receiveMessageTasks.forEach(task => {
            task(response);
           // if(response.notificationType == 3)
        });
    });
}

function addReceiveMessageTask(task){
    window.receiveMessageTasks.push(task);
}

export {
    initSignalR,
    addReceiveMessageTask
}
